import { render, staticRenderFns } from "./scoreEvaluation.vue?vue&type=template&id=530ce57c&scoped=true"
import script from "./scoreEvaluation.vue?vue&type=script&lang=js"
export * from "./scoreEvaluation.vue?vue&type=script&lang=js"
import style0 from "./scoreEvaluation.vue?vue&type=style&index=0&id=530ce57c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ce57c",
  null
  
)

export default component.exports